<template>
  <div v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100">
  </div>
  <main class="main-content position-relative max-height-vh-100 h-100" :style="mainStyle">
    <div class="page-header min-vh-100">
      <div class="container">
        <div class="row">
          <div class="mx-auto col-xl-12 col-lg-12 col-md-12 d-flex flex-column mx-lg-0" align="center"
            style="margin-top: 10px;">
            <img :src="logo" style="width: 150px; margin: 0 auto; margin-bottom: 50px;">
          </div>
        </div>
        <div class="row">
          <div class="mx-auto col-xl-12 col-lg-12 col-md-12 d-flex flex-column mx-lg-0" align="center">
            <router-view style="border: 2px solid #021631; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);
    -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);
    box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { mapMutations } from "vuex";
import logo from "@/assets/img/telemidia_light.png"
import 'bootstrap';
import { isTokenExpired } from './helpers/jwt.js'
import userService from './services/user.js'

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load()

export default {
  name: "App",
  components: {
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"])
  },
  computed: {
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    ; (async () => {
      // Get the visitor identifier when you need it.
      const fp = await fpPromise
      const result = await fp.get()

      const fingerprint = result.visitorId
      const fingerprintComponents = JSON.stringify(result.components)
      const fingerprintConfidence = result.confidence.score

      localStorage.setItem('fingerprint', fingerprint)
      localStorage.setItem('fingerprintComponents', fingerprintComponents)
      localStorage.setItem('fingerprintConfidence', fingerprintConfidence)
    })()

    const token = localStorage.getItem('token');
    const termos = localStorage.getItem('termos')

    // Invalida a sessão e envia o usuário para a tela inicial, caso o token tiver expirado, ou caso o cliente não tiver termos
    if (!token || (token && isTokenExpired(token)) || !termos || termos.length == 0) {
      userService.revokeSession(this);
    }

  },
  data() {
    return {
      mainStyle: {
        background: `linear-gradient(to bottom, rgba(0, 0, 132, 0.90), rgba(19, 58, 165, 0.95)), url(${require('@/assets/img/background.png')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100vw',
      },
      logo
    }
  }
};
</script>
